<template>
  <StandardResourceService
    title="山姆直连"
    v-model="activeTab"
    :tab-list="tabList">
    <AssociatedGoodsComponent v-if="activeTab === 'associatedGoods'"></AssociatedGoodsComponent>
    <OrderRecordsComponent v-else-if="activeTab === 'orderRecord'"></OrderRecordsComponent>
  </StandardResourceService>
</template>

<script>
import StandardResourceService from '@/customComponents/standard/StandardResourceService.vue'
import AssociatedGoodsComponent from './components/AssociatedGoodsComponent.vue'
import OrderRecordsComponent from './components/OrderRecordsComponent.vue'

export default {
  name: 'SamHome',
  components: {
    StandardResourceService,
    AssociatedGoodsComponent,
    OrderRecordsComponent
  },
  data () {
    return {
      activeTab: 'associatedGoods',
      tabList: [
        { label: '关联商品', key: 'associatedGoods' },
        { label: '订单记录', key: 'orderRecord' }
      ]
    }
  }
}
</script>

<style scoped lang="less">
</style>
